import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleResidenceSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#56A" opacity={0.88} cx={28} cy={28} r={28} />
        <path
          d="M30 16.423a.5.5 0 01.138.02l11.5 3.297a.5.5 0 01.362.48V37.5a.5.5 0 01-.5.5h-3.7v-4.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V38h-4.3V16.923a.5.5 0 01.5-.5zM39.2 29h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm0-3.5h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm0-3.5h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
          fill="#8E9FCC"
        />
        <path
          d="M27.944 12.592a.5.5 0 01.056.23V38H14.5a.5.5 0 01-.5-.5V19.563a.5.5 0 01.27-.444l13-6.74a.5.5 0 01.674.213zM18 20.8L16 22v13.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V20.8zm4-2L20 20v15.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V18.8zm4-2L24 18v17.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V16.8z"
          fill="#FFF"
        />
        <rect fill="#FFF" x={12} y={39.5} width={32} height={2.5} rx={0.5} />
      </g>
    </svg>
  );
}

SvgPicCircleResidenceSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleResidenceSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleResidenceSelected svgRef={ref} {...props} />
));
export default ForwardRef;
